<template>
  <footer class="mainfooter" role="contentinfo" id="footer">
    <footer-container-area :data="pageText.containerAreaContents"></footer-container-area>
    <footer-copy-right-area :data="pageText.copyrightAreaContents"></footer-copy-right-area>
  </footer>
  <!-- footer -->
</template>

<script>

import FooterCopyRightArea from '@/components/shared/footer/footerComponents/FooterCopyRightArea'
import FooterContainerArea from '@/components/shared/footer/footerComponents/FooterContainerArea'

import footer from '@/assets/cms_templates_repo/styl.json'

export default {
	components: {

		FooterCopyRightArea,
		FooterContainerArea
	},
	data () {
		return {
			pageText:
        footer.components.uielements.footers['footer-type-1'].widgetProperties
		}
	}
}
</script>
